'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useEffect, useState } from 'react'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'
import PropTypes from 'prop-types'

export const RemunerationSelect = ({
  testData = null,
  crmSchemeId,
  privateOrLegalAid,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  required = false,
  menuZindex = 1100,
  size = 'small',
  errors = {},
  name = 'remunerationTypeId',
  menuWidth = null
}) => {
  const { fetchRemunerationTypes, remunerationTypes } = useLookupsStore()
  const { remunerationType } = useNewMatterStore()
  const [isDisabled, setIsDisabled] = useState(false)
  const [selectedValue, setSelectedValue] = useState(value)
  const [options, setOptions] = useState(testData || remunerationTypes || [])

  useEffect(() => {
    if (testData) return
    setOptions(remunerationTypes || [])
  }, [testData, remunerationTypes])

  useEffect(() => {
    if (testData) return
    const invalid = crmSchemeId === null || crmSchemeId === undefined || !privateOrLegalAid
    if (invalid) return
    fetchRemunerationTypes({ crmSchemeId, privateOrLegalAid })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, crmSchemeId, privateOrLegalAid, isDisabled])

  useEffect(() => {
    const invalidCrmSchemeId = crmSchemeId === null || crmSchemeId === undefined
    setIsDisabled(invalidCrmSchemeId || !privateOrLegalAid)
  }, [crmSchemeId, privateOrLegalAid])

  useEffect(() => {
    if (remunerationType) {
      setSelectedValue(remunerationType)
    } else {
      setSelectedValue(value)
    }
  }, [value, remunerationType])

  return (
    <div data-testid="RemunerationSelect" style={{ ...sx }}>
      <ReactSelectMenu
        label="Remuneration ID"
        name={name}
        disabled={isDisabled}
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        items={options}
        value={selectedValue || null}
        sx={{ width: '100%' }}
        searchable
        valueKey="remunerationTypeId"
        labelKey="description"
        required={required}
        menuZindex={menuZindex}
        menuWidth={menuWidth}
        size={size}
        errors={errors}
      />
    </div>
  )
}

RemunerationSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  crmSchemeId: PropTypes.number,
  privateOrLegalAid: PropTypes.string,
  sx: PropTypes.object,
  required: PropTypes.bool,
  menuZindex: PropTypes.number,
  size: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.object,
  menuWidth: PropTypes.string
}
